﻿import buttonLoader from "../../utilities/buttonLoader.js";

var mypage = {};

const scrollToSubscription = (button) => {
	if (!button) return;

	const subscriptionContainer = button.closest(".tableFlex__cell");
	if (!subscriptionContainer) return;

	const subscriptionName = subscriptionContainer.querySelector(
		".classList__subscription-name",
	);
	const targetElement = subscriptionName || subscriptionContainer;

	const rect = targetElement.getBoundingClientRect();
	const offset = 20;
	const targetY = rect.top + window.scrollY - offset;

	window.scrollTo({
		top: targetY,
		behavior: "smooth",
	});
};

mypage = {
	init: function () {
		this.logout();
		this.subscriptionToggle();
	},

	logout: () => {
		var button = document.getElementsByClassName("mypage__logout")[0];

		if (button) {
			button.addEventListener("click", () => {
				buttonLoader.start(button);
			});
		}
	},

	subscriptionToggle: () => {
		const toggleButtons = document.querySelectorAll(".js-toggle-subscription");

		toggleButtons.forEach((button) => {
			button.addEventListener("click", () => {
				const subscriptionId = button.getAttribute("data-subscription");
				const hiddenItems = document.querySelectorAll(
					`[data-subscription="${subscriptionId}"].subscription-item-hidden`,
				);
				const textShow = button.getAttribute("data-text-show");
				const textHide = button.getAttribute("data-text-hide");
				const isExpanded = button.classList.contains("expanded");

				hiddenItems.forEach((item) => {
					if (isExpanded) {
						item.style.display = "none";
					} else {
						item.style.display = "";
					}
				});

				if (isExpanded) {
					button.textContent = textShow;
					button.classList.remove("expanded");
					setTimeout(() => scrollToSubscription(button), 100);
				} else {
					button.textContent = textHide;
					button.classList.add("expanded");
				}
			});
		});
	},
};

mypage.initialize = () => {
	mypage.init();
};

module.exports = mypage;
